"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildShopperPlatformPageUrlFromDealXgId = exports.buildShopperPlatformPageUrlFromSessionId = exports.buildShopperPlatformPageUrl = exports.buildShopperPlatformPageUrlFromVdp = exports.extractDsEnvFromUrl = exports.isLocalVdpUrl = exports.useConfigForUrl = void 0;
var dr_common_utils_1 = require("@makemydeal/dr-common-utils");
// Exported Functions
var useConfigForUrl = function (hostVdpUrl) {
    // for widget-test pages we'll need to use config
    return (hostVdpUrl &&
        (hostVdpUrl.startsWith('http://dealstarter-test.makemydeal') ||
            hostVdpUrl.startsWith('https://dealstarter-test.makemydeal')));
};
exports.useConfigForUrl = useConfigForUrl;
var isLocalVdpUrlWithProtocol = function (vdpUrl, protocol) {
    // when running locally we'll use localhost
    return (vdpUrl &&
        (vdpUrl.startsWith("".concat(protocol, "://localhost:")) ||
            vdpUrl.startsWith("".concat(protocol, "://w2.makemydealpreview.com:")) ||
            vdpUrl.startsWith("".concat(protocol, "://dealstarter.makemydeal.dev:"))));
};
var isLocalVdpUrl = function (vdpUrl) {
    // when running locally we'll use localhost
    return isLocalVdpUrlWithProtocol(vdpUrl, 'http') || isLocalVdpUrlWithProtocol(vdpUrl, 'https');
};
exports.isLocalVdpUrl = isLocalVdpUrl;
var extractDsEnvFromUrl = function (url) {
    var regex = new RegExp("(.*)[?&]ds[eE]nv=(.*)(&*)");
    var matches = regex.exec(url);
    if (matches === null) {
        return null;
    }
    else {
        return matches.length === 4 ? matches[2] : null;
    }
};
exports.extractDsEnvFromUrl = extractDsEnvFromUrl;
var buildShopperPlatformPageUrlWithoutSponsor = function (objParams) {
    var hostVdpUrl = objParams.hostVdpUrl, frameUrl = objParams.frameUrl, spConfigUrl = objParams.spConfigUrl, connectionId = objParams.connectionId, vin = objParams.vin, dealXgId = objParams.dealXgId, pencilId = objParams.pencilId;
    var baseUrl;
    if ((0, exports.isLocalVdpUrl)(frameUrl)) {
        // all local
        baseUrl = 'http://w2.makemydealpreview.com:5601/shells/main.html';
    }
    else if ((0, exports.useConfigForUrl)(hostVdpUrl)) {
        // build URL based on config
        baseUrl = spConfigUrl;
    }
    else {
        // build relative URL
        var schemeAndHost = dr_common_utils_1.urlSlicer.extractSchemeAndDomain(hostVdpUrl);
        if (schemeAndHost === null) {
            schemeAndHost = 'https://mmddemo.cms.dealer.com/';
        }
        var relativeUrl = '/shopper-platform.htm';
        baseUrl = dr_common_utils_1.urlBuilder.combine(schemeAndHost, relativeUrl);
    }
    var dsEnv = (0, exports.extractDsEnvFromUrl)(hostVdpUrl);
    var appendDsEnv = dsEnv ? "&dsEnv=".concat(dsEnv) : '';
    var url = dealXgId
        ? "".concat(baseUrl, "?dealXgId=").concat(dealXgId).concat(appendDsEnv)
        : "".concat(baseUrl, "?connectionId=").concat(connectionId, "&vin=").concat(vin).concat(appendDsEnv);
    if (pencilId) {
        url = url.concat("&pencilId=".concat(pencilId));
    }
    return url;
};
var buildShopperPlatformPageUrlFromVdp = function (objParams) {
    var hostVdpUrl = objParams.hostVdpUrl, connectionId = objParams.connectionId, dealXgId = objParams.dealXgId, vin = objParams.vin, dsRoute = objParams.dsRoute, pencilId = objParams.pencilId;
    var baseUrl = dr_common_utils_1.urlSlicer.extractSchemeDomainAndPath(hostVdpUrl, { removeQueryString: true });
    var params = dr_common_utils_1.urlSlicer.parseParams(hostVdpUrl);
    if (connectionId && vin) {
        params['dsConnectionId'] = connectionId;
        params['dsVin'] = vin;
    }
    if (dealXgId) {
        params['dealXgId'] = dealXgId;
    }
    if (dsRoute) {
        params['dsRoute'] = dsRoute;
    }
    var paramsAsQueryString = dr_common_utils_1.urlBuilder.paramsToQueryString(params);
    var newUrl = dr_common_utils_1.urlBuilder.buildWithQueryString(baseUrl, paramsAsQueryString);
    if (pencilId) {
        newUrl = newUrl.concat("&pencilId=".concat(pencilId));
    }
    return newUrl;
};
exports.buildShopperPlatformPageUrlFromVdp = buildShopperPlatformPageUrlFromVdp;
var buildShopperPlatformPageUrl = function (objParams) {
    var hostVdpUrl = objParams.hostVdpUrl, frameUrl = objParams.frameUrl, spConfigUrl = objParams.spConfigUrl, connectionId = objParams.connectionId, vin = objParams.vin, dealXgId = objParams.dealXgId, sponsor = objParams.sponsor, dsRoute = objParams.dsRoute, onPlatform = objParams.onPlatform, pencilId = objParams.pencilId, _a = objParams.isShowroom, isShowroom = _a === void 0 ? false : _a;
    var url;
    if (!sponsor || onPlatform) {
        url = buildShopperPlatformPageUrlWithoutSponsor({
            hostVdpUrl: hostVdpUrl,
            frameUrl: frameUrl,
            spConfigUrl: spConfigUrl,
            connectionId: connectionId,
            vin: vin,
            dealXgId: dealXgId,
            pencilId: pencilId
        });
    }
    else {
        url = (0, exports.buildShopperPlatformPageUrlFromVdp)({ hostVdpUrl: hostVdpUrl, connectionId: connectionId, vin: vin, dealXgId: dealXgId, dsRoute: dsRoute, pencilId: pencilId });
    }
    var appendShowroom = isShowroom ? "&isShowroom=".concat(isShowroom) : '';
    url = url.concat(appendShowroom);
    return url;
};
exports.buildShopperPlatformPageUrl = buildShopperPlatformPageUrl;
var buildShopperPlatformPageUrlFromSessionId = function (objParams) {
    var spUrl = objParams.spUrl, sessionId = objParams.sessionId, dsRoute = objParams.dsRoute, theme = objParams.theme, dealXgId = objParams.dealXgId;
    var params = __assign(__assign(__assign({}, (sessionId && { sessionId: sessionId })), { route: dsRoute, theme: theme || 'default' }), (dealXgId && { dealXgId: dealXgId }));
    var paramsAsQueryString = dr_common_utils_1.urlBuilder.paramsToQueryString(params);
    var newUrl = dr_common_utils_1.urlBuilder.buildWithQueryString(spUrl, paramsAsQueryString);
    return "".concat(newUrl, "&enableToggles=enableP202Redesign");
};
exports.buildShopperPlatformPageUrlFromSessionId = buildShopperPlatformPageUrlFromSessionId;
var buildShopperPlatformPageUrlFromDealXgId = function (objParams) {
    var spUrl = objParams.spUrl, dsRoute = objParams.dsRoute, theme = objParams.theme, dealXgId = objParams.dealXgId, sponsor = objParams.sponsor;
    if (!dealXgId) {
        throw Error('Deal Exchange Id is required');
    }
    var params = {
        route: dsRoute,
        theme: theme || 'default',
        dealXgId: dealXgId
    };
    if (sponsor) {
        params['sponsor'] = sponsor;
    }
    var paramsAsQueryString = dr_common_utils_1.urlBuilder.paramsToQueryString(params);
    var newUrl = dr_common_utils_1.urlBuilder.buildWithQueryString(spUrl, paramsAsQueryString);
    return newUrl;
};
exports.buildShopperPlatformPageUrlFromDealXgId = buildShopperPlatformPageUrlFromDealXgId;
